import { MasterType } from '@/common/model/master/w2Master'

import CsvUploadArea from '@/components/container/form/widgets/csv/CsvUploadArea'
import CsvUploadFormContent from '@/components/container/form/widgets/csv/CsvUploadFormContent'

import { useOrderCsvUploadApiForm } from './orderCsvUploadSchema'

interface Props {
  siteId: number
  onClickClose(): void
}

const OrderCsvUploadForm = ({ siteId, onClickClose }: Props) => {
  const { result, control, errors, onSubmit, reset } = useOrderCsvUploadApiForm(siteId)

  return (
    <form onSubmit={onSubmit}>
      <CsvUploadFormContent
        result={result}
        reset={reset}
        onClickClose={onClickClose}
        control={control}
        errors={errors}
      >
        <CsvUploadArea
          siteId={siteId}
          masterType={MasterType.ORDERS}
          control={control}
          errors={errors}
        />
      </CsvUploadFormContent>
    </form>
  )
}

export default OrderCsvUploadForm
